import { Language } from '@rbilabs/intl';
import { conformToMask } from 'react-text-mask';

import { format } from 'utils/language/format-date';

const localizedDateTimeFormats = {
  'en-US': {
    date: 'MMMM d, yyyy',
    time: 'h:m aaaa',
  },
};

interface ILocalizedDateTime {
  date: string;
  time: string;
}

export const localizedDateTimeFormatter = (
  dateTime: string,
  locale: string
): ILocalizedDateTime => {
  const splitDateTime = dateTime.split(/\s/);
  const date = splitDateTime[0];
  const time = splitDateTime.slice(1).join(' ');

  /**
   * We're tacking on this 00:00 so that `Date` interprets the input `date` correctly
   * Without this, `2020-01-28` could be interpreted as `January 27, 2020`.
   *
   * Ideally, we'd just pass in the whole `dateTime`, but that's improperly formatted,
   * as identified here: https://rbictg.atlassian.net/browse/CBA-4083
   */
  const formattedDate = format(
    new Date(`${date}T00:00`),
    localizedDateTimeFormats[locale].date,
    Language.en
  );

  return {
    date: formattedDate,
    time,
  };
};

const localizedCountryCodes = {
  'en-US': '+1',
  'en-CA': '+1',
};

// ex. `9543214567` -> `(954) 321 4567`
const phoneNumberMask = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const formatPhoneNumber = (phoneNumber: string, locale: string): string => {
  const phoneNumberWithoutCountryCode = phoneNumber?.replace(localizedCountryCodes[locale], '');
  const { conformedValue } = conformToMask(phoneNumberWithoutCountryCode, phoneNumberMask, {});
  return conformedValue;
};
